<a-spinner [hidden]="!hasPendingRequests"></a-spinner>
<router-outlet></router-outlet>
